<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-gray-400 my-3">Detalhe da Transferência #{{ transfer?.id }}</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="p-4 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                <p class="text-sm text-gray-400">ID</p>
                <p class="text-lg text-gray-800 dark:text-gray-200">{{ transfer?.id }}</p>

                <p class="text-sm text-gray-400 mt-3">Cashout ID</p>
                <p class="text-lg text-gray-800 dark:text-gray-200">{{ transfer?.cashout_id }}</p>

                <p class="text-sm text-gray-400 mt-3">Usuário</p>
                <p>
                    <button class="text-indigo-500 hover:underline" v-if="transfer?.user" @click.prevent="manageUser(transfer.user)">
                        {{ transfer.user.name }} ({{ transfer.user.email }})
                    </button>
                </p>

                <p class="text-sm text-gray-400 mt-3">Provider</p>
                <p class="text-lg text-gray-800 dark:text-gray-200">{{ transfer?.provider }}</p>

                <p class="text-sm text-gray-400 mt-3">Status</p>
                <p>
                    <span class="text-sm font-medium mr-2 px-2.5 py-1.5 rounded" :class="statusClass(transfer?.status)">
                        {{ statusName(transfer?.status) }}
                    </span>
                </p>

                <p class="text-sm text-gray-400 mt-3">Taxa</p>
                <p class="text-lg text-gray-800 dark:text-gray-200">{{ $root.formatCurrency(transfer?.fee || 0) }}</p>

                <p class="text-sm text-gray-400 mt-3">External ID</p>
                <p class="text-lg text-gray-800 dark:text-gray-200 break-all">{{ transfer?.external_id }}</p>

                <p class="text-sm text-gray-400 mt-3">Criado em</p>
                <p class="text-lg text-gray-800 dark:text-gray-200">{{ transfer?.created_at }}</p>

                <p class="text-sm text-gray-400 mt-3">Atualizado em</p>
                <p class="text-lg text-gray-800 dark:text-gray-200">{{ transfer?.updated_at }}</p>
            </div>

            <div class="p-4 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                <p class="text-md text-gray-700 dark:text-gray-200 font-semibold mb-2">Histórico</p>
                <div v-if="Array.isArray(transfer?.historic) && transfer.historic.length > 0" class="space-y-2">
                    <div v-for="(h, idx) in transfer.historic" :key="idx" class="rounded border p-2 border-slate-200 dark:border-slate-700">
                        <p class="text-sm text-gray-400">Status</p>
                        <p class="text-sm">{{ h.status || '-' }}</p>
                        <p class="text-sm text-gray-400 mt-2">Data</p>
                        <p class="text-sm">{{ h.data || h.date || '-' }}</p>
                        <p class="text-sm text-gray-400 mt-2">Operador</p>
                        <p class="text-sm">{{ h.cod_operador || '-' }}</p>
                    </div>
                </div>
                <div v-else class="text-sm text-gray-500">Sem histórico disponível.</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapWritableState } from "pinia";
import { Store } from "../../../stores/store";

export default {
    data() {
        return {
            loading: false,
            transfer: null,
        };
    },
    computed: {
        ...mapWritableState(Store, ['user']),
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.loading = true;
            axios.get(`/api/financial/transfer/${this.$route.params.transfer_id}`).then(({ data }) => {
                this.transfer = data;
                this.loading = false;
            }).catch(() => { this.loading = false; });
        },
        manageUser(user) {
            if (!user) return;
            this.user = user;
            this.$router.push({ name: 'user.commissions', params: { user_id: user.id } });
        },
        statusName(status) {
            switch (status) {
                case 'pending_authorization': return 'Pendente de Autorização';
                case 'pending_execution': return 'Pendente de Efetivação';
                case 'authorized': return 'Autorizado';
                case 'completed': return 'Concluído';
                case 'rejected': return 'Rejeitado';
                case 'pending_change': return 'Pendente de Alteração';
                case 'rejected_on_file': return 'Rejeitado no Arquivo';
                default: return status;
            }
        },
        statusClass(status) {
            return {
                'bg-yellow-500 text-white': ['pending_authorization','pending_execution','pending_change'].includes(status),
                'bg-green-500 text-white': status === 'completed' || status === 'authorized',
                'bg-red-500 text-white': status === 'rejected' || status === 'rejected_on_file',
            };
        }
    }
}
</script>

